import { DRAWER_WIDTH, RESPONSIVE_PADDING, SCREEN_WIDTH } from 'constants/ui';

export const getDrawerProps = (width = DRAWER_WIDTH) => ({
  sx: {
    position: 'fixed',
    zIndex: 1300,
    '& .MuiDrawer-paper': {
      width,
      maxWidth: '100%',
      padding: RESPONSIVE_PADDING.DESKTOP,
      // Native (notched) devices: the full-height drawer paper starts under the status bar /
      // Dynamic Island — add the top safe-area to the top padding so its header/close clears it
      // (0 in a browser → desktop unaffected). Per-breakpoint since the padding differs.
      paddingTop: `calc(${RESPONSIVE_PADDING.DESKTOP} + env(safe-area-inset-top, 0px))`,
      backgroundColor: ({ palette }) => palette.background.disabled,
      position: 'absolute',

      [`@media(max-width: ${SCREEN_WIDTH.M - 1}px)`]: {
        width: '100%',
        padding: RESPONSIVE_PADDING.MOBILE,
        paddingTop: `calc(${RESPONSIVE_PADDING.MOBILE} + env(safe-area-inset-top, 0px))`,
      },

      [`@media(min-width: ${SCREEN_WIDTH.M}px) and (max-width: ${SCREEN_WIDTH.L - 1}px)`]: {
        width: width === DRAWER_WIDTH ? 'calc(100% - 100px)' : width,
        padding: RESPONSIVE_PADDING.TABLET,
        paddingTop: `calc(${RESPONSIVE_PADDING.TABLET} + env(safe-area-inset-top, 0px))`,
      },
    },
    '& .MuiBackdrop-root': {
      zIndex: 1300,
    },
  },
});

export const slideProps = {
  timeout: { enter: 300, exit: 300 },
  appear: true,
  tabIndex: 'unset',
};

export const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '16px',
  },

  title: {
    fontSize: '1.8rem',
    fontWeight: 600,
  },

  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    boxShadow: ({ palette }) => palette.shadow.m,
    backgroundColor: ({ palette }) => palette.background.paper,
    borderRadius: '4px',
    overflow: 'hidden',
  },

  formContent: {
    display: 'flex',
    flex: 1,
    overflow: 'auto',
    padding: '24px 24px 0',
  },

  divider: {
    borderColor: ({ palette }) => palette.border.default,
  },

  controlsWrapper: {
    display: 'flex',
    padding: '16px 24px',
    justifyContent: 'end',
    gap: '8px',
  },

  button: {
    borderRadius: '6px',
    textTransform: 'none',
    fontSize: '1.2rem',
    boxShadow: 'none !important',
    borderColor: ({ palette }) => palette.primary.main,
  },
};
